import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Folder, ShieldPlus, Trash2 } from "lucide-react";
import { VIS } from "./constants";

/**
 * One folder in the admin grid. Hover reveals per-user ACL shield + delete.
 * The `+N users` badge (R147a) surfaces per-user grants without opening
 * the modal — makes it obvious which folders have exceptions.
 */
export function FolderCard({ folder, onOpen, onDelete, onManageAcl }) {
  const meta = VIS.find((v) => v.value === folder.visibility) || VIS[0];
  const aclCount = (folder.allowed_user_ids || []).length;

  return (
    <Card className="border-white/10 p-3 hover:border-white/25 group relative"
          data-testid={`docs-folder-${folder.id}`}>
      <button onClick={() => onOpen(folder)} className="text-left w-full">
        <div className="flex items-start gap-2">
          <Folder className="h-7 w-7 text-orange-400/70 shrink-0 mt-0.5" />
          <div className="flex-1 min-w-0">
            <div className="text-sm text-zinc-100 truncate">{folder.name}</div>
            {folder.description && (
              <div className="text-[11px] text-zinc-500 line-clamp-2 mt-0.5"
                   data-testid={`docs-folder-desc-${folder.id}`}>
                {folder.description}
              </div>
            )}
            <div className="mt-1.5 flex items-center gap-1 flex-wrap">
              <Badge variant="outline" className={"text-[10px] " + meta.tone}>{meta.label}</Badge>
              {aclCount > 0 && (
                <Badge variant="outline" className="text-[10px] border-amber-500/40 text-amber-300"
                       data-testid={`docs-folder-acl-count-${folder.id}`}>
                  +{aclCount} user{aclCount === 1 ? "" : "s"}
                </Badge>
              )}
            </div>
          </div>
        </div>
      </button>
      <div className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 flex items-center gap-0.5">
        <button onClick={(e) => { e.stopPropagation(); onManageAcl(folder); }}
                className="text-zinc-500 hover:text-sky-300 p-1"
                title="Manage per-user access"
                data-testid={`docs-folder-acl-${folder.id}`}>
          <ShieldPlus className="h-3.5 w-3.5" />
        </button>
        <button onClick={(e) => { e.stopPropagation(); onDelete(folder); }}
                className="text-zinc-500 hover:text-red-300 p-1"
                data-testid={`docs-folder-delete-${folder.id}`}>
          <Trash2 className="h-3 w-3" />
        </button>
      </div>
    </Card>
  );
}
